import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=caf226fe&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=caf226fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf226fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf226fe')) {
      api.createRecord('caf226fe', component.options)
    } else {
      api.reload('caf226fe', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=caf226fe&scoped=true&", function () {
      api.rerender('caf226fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gr4SuFErSqSY/JS/comp/SearchFilterTokens.vue"
export default component.exports